export const BUSINESS_TYPE_OPTIONS = [
  {
    id: 'retail',
    label: 'Retail Shop',
    description: 'Walk-in sales, cashier speed, stock visibility, and repeat-customer growth.',
    icon: '🏪',
    accent: '#2563EB',
    tint: '#EFF6FF',
  },
  {
    id: 'wholesale',
    label: 'Wholesale',
    description: 'Bulk buyers, supplier-led restocking, trade credit, and invoice-style selling.',
    icon: '📦',
    accent: '#0F766E',
    tint: '#ECFDF5',
  },
  {
    id: 'retail_wholesale',
    label: 'Retail & Wholesale',
    description: 'One stock and cashflow view for both counter sales and bulk customer orders.',
    icon: '🛒',
    accent: '#D97706',
    tint: '#FFF7ED',
  },
  {
    id: 'other',
    label: 'Other Trade Business',
    description: 'Still stock-led, but not a standard shop or bulk-sales model yet.',
    icon: '🧾',
    accent: '#7C3AED',
    tint: '#F5F3FF',
  },
];

const BUSINESS_TYPE_MAP = Object.fromEntries(BUSINESS_TYPE_OPTIONS.map((option) => [option.id, option]));

export function getBusinessTypeMeta(type) {
  return BUSINESS_TYPE_MAP[type] || BUSINESS_TYPE_MAP.retail;
}
